"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStencilPopper = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _core = require("@popperjs/core");

var _reactFastCompare = _interopRequireDefault(require("react-fast-compare"));

var _comparisons = require("../utils/comparisons");

var _useIsomorphicLayoutEffect = require("./useIsomorphicLayoutEffect");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var useStencilPopper = function useStencilPopper(referenceElement, popperElement) {
  var isOpen = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var optionsWithDefaults = {
    modifiers: options.modifiers || [],
    onFirstUpdate: options.onFirstUpdate,
    placement: options.placement || 'bottom',
    strategy: options.strategy || 'absolute'
  }; // State to trigger useEffect if referenced components aren't null yet

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      trigger = _useState2[0],
      setTrigger = _useState2[1];

  var _useState3 = (0, _react.useState)({
    arrow: {
      position: 'absolute'
    },
    popper: {
      position: optionsWithDefaults.strategy,
      left: '0',
      top: '0'
    }
  }),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      styles = _useState4[0],
      setStyles = _useState4[1];

  var _useState5 = (0, _react.useState)(optionsWithDefaults.placement),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      placement = _useState6[0],
      setPlacement = _useState6[1];

  var prevOptions = (0, _react.useRef)(null);
  var prevStyles = (0, _react.useRef)(null);
  var dynamicPhase = (0, _react.useRef)('beforeWrite');
  var popperInstanceRef = (0, _react.useRef)(null); // refactored modifier to deeply check old and new styles object to update local state

  var updateStateModifier = (0, _react.useMemo)(function () {
    return {
      enabled: true,
      fn: function fn(_ref) {
        var state = _ref.state;
        if (state && !state.elements) return; // set placement from instance's state to have fresh position

        if (placement !== state.placement && state.modifiersData.isOpen) {
          setPlacement(state.placement);
        }

        var newStyles = Object.keys(state.elements).map(function (element) {
          return [element, state.styles[element] || {}];
        }).reduce(function (acc, _ref2) {
          var _ref3 = (0, _slicedToArray2.default)(_ref2, 2),
              key = _ref3[0],
              value = _ref3[1];

          acc[key] = value;
          return acc;
        }, {}); // update only params to avoid frequent updates

        if (prevStyles.current === null || !(0, _comparisons.isDeepEqual)(prevStyles.current, newStyles)) {
          setStyles(newStyles);
        }

        prevStyles.current = newStyles; // using "beforeWrite" phase to solve initial set up
        // then set to default "write" phase that tracks scroll/resize events

        if (dynamicPhase.current === 'beforeWrite') {
          dynamicPhase.current = 'write';
        }
      },
      name: 'updateState',
      options: {
        placement: placement
      },
      phase: dynamicPhase.current,
      requires: ['computeStyles']
    };
  }, [dynamicPhase, placement, setStyles]);
  var popperOptions = (0, _react.useMemo)(function () {
    var eventListenerOptions = {
      resize: false,
      scroll: true
    };
    var newOptions = {
      onFirstUpdate: optionsWithDefaults.onFirstUpdate,
      placement: optionsWithDefaults.placement,
      strategy: optionsWithDefaults.strategy,
      modifiers: [].concat((0, _toConsumableArray2.default)(optionsWithDefaults.modifiers), [_objectSpread(_objectSpread({}, updateStateModifier), {}, {
        enabled: isOpen
      }), {
        name: 'applyStyles',
        phase: 'afterRead',
        enabled: true
      }, _objectSpread(_objectSpread({}, _core.eventListeners), {}, {
        enabled: isOpen,
        options: eventListenerOptions
      })])
    };

    if (prevOptions.current && (0, _reactFastCompare.default)(prevOptions.current, newOptions)) {
      return prevOptions.current || newOptions;
    } else {
      prevOptions.current = newOptions;
      return newOptions;
    }
  }, [optionsWithDefaults.onFirstUpdate, optionsWithDefaults.strategy, optionsWithDefaults.modifiers, optionsWithDefaults.placement, updateStateModifier, isOpen]); // set new options passed in argument

  (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function () {
    if (popperInstanceRef.current) {
      popperInstanceRef.current.setOptions(popperOptions);
    }
  }, [popperOptions]); // Initialize Popper instance

  (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function () {
    if (referenceElement == null || popperElement == null) {
      setTrigger(true);
      return;
    }

    var createPopper = options.createPopper || _core.createPopper;
    var popperInstance = createPopper(referenceElement, popperElement, popperOptions); // initially isOpen should be true

    popperInstance.state.modifiersData.isOpen = true;
    popperInstanceRef.current = popperInstance; // To fix: https://t.corp.amazon.com/D104449106
    // When dropdown is open and window resizes, computes position correctly

    var timer;

    var forceUpdate = function forceUpdate() {
      clearTimeout(timer);
      timer = setTimeout(function () {
        popperInstance.forceUpdate();
      }, 0);
    };

    window.addEventListener('resize', forceUpdate);
    return function () {
      popperInstance.destroy();
      popperInstanceRef.current = null;
      window.removeEventListener('resize', forceUpdate);
    };
  }, [referenceElement, popperElement, options.createPopper, trigger]); // update instance state isOpen

  (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function () {
    if (popperInstanceRef.current) {
      popperInstanceRef.current.state.modifiersData.isOpen = isOpen;
      popperInstanceRef.current.forceUpdate();
    }
  }, [popperInstanceRef, isOpen]);
  return {
    forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null,
    placement: placement,
    state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
    styles: styles || {},
    update: popperInstanceRef.current ? popperInstanceRef.current.update : null
  };
};

exports.useStencilPopper = useStencilPopper;